const indices = [
  { title: '91免费在线视频精选', desc: '每日精选最热门91免费在线视频，不容错过的精彩内容合集。', icon: 'ri-star-line', count: '326部' },
  { title: '91免费视频网站热门榜', desc: '综合播放量与用户评分，实时呈现91免费视频网站最火内容。', icon: 'ri-fire-line', count: 'TOP50' },
  { title: '91福利在线视频专区', desc: '品质精选福利频道，91福利在线视频一网打尽，持续更新中。', icon: 'ri-gift-line', count: '189部' },
  { title: '免费视频在线观看指南', desc: '新用户快速上手，了解如何高效浏览在线免费视频网站的所有内容。', icon: 'ri-guide-line', count: '入门' },
  { title: '免费高清视频在线推荐', desc: '画质优先，精选全网最高清免费高清视频在线资源，视觉享受。', icon: 'ri-4k-line', count: '215部' },
  { title: '91在线观看视频网站专题', desc: '按题材分类的专题合集，91在线观看视频网站一站式内容索引。', icon: 'ri-folder-line', count: '42个' },
  { title: '91福利视频在线精选', desc: '人气最高的91福利视频在线内容，持续追踪用户最爱。', icon: 'ri-heart-line', count: '158部' },
];

export default function SectionIndex() {
  return (
    <section id="index" className="bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 text-center mb-2">专题索引</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">91麻豆免费视频网站全部专题分类，快速找到感兴趣的内容</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indices.map((item, i) => (
            <a
              key={i}
              href="#media"
              className={`group block p-5 rounded-xl border border-background-200 bg-background-50 hover:border-primary-300 hover:shadow-lg hover:shadow-primary-100/50 transition-all duration-200 cursor-pointer ${
                i === 6 ? 'sm:col-span-2 lg:col-span-1' : ''
              }`}
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-500 transition-colors duration-200">
                  <i className={`${item.icon} text-primary-600 group-hover:text-white text-lg transition-colors duration-200`}></i>
                </div>
                <span className="text-xs font-medium text-primary-600 bg-primary-50 px-2 py-0.5 rounded-full whitespace-nowrap">{item.count}</span>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-1.5">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}